<template>
  <!-- 线下课下单页 -->
  <div
    v-if="!showInfo"
    class="order-info"
    v-wechat-title="dataInfo.name || '订单'"
    v-gxxt-loading="loading"
  >
    <div class="order-list">
      <div class="order-box">
        <div class="c-thumb">
          <img :src="dataInfo.imageV" alt />
        </div>
        <div class="o-content">
          <div class="c-title">{{dataInfo.name}}</div>
          <div>
            <div class="c-price">
              <div class="f40 color-f5 fb">
                <span class="f30 fb">¥</span>
                {{dataInfo.newPrice}}
                <span class="c-x-1" v-if="disabled">x1</span>
              </div>
              <input-number v-if="!disabled" @change="changeBuyNum" v-model="buyNum" :min="1"></input-number>
            </div>
            <!-- 团购 -->
            <div class="text" v-if="isGoodsGroup==1 || (isGoodsStatus == 'true' && isGoodsGroup ==0 && goodsType!=1)">
              <span class="fb">多买优惠</span>
              <span class="fb">每份到手价 ¥{{curPackage.newPrice}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="c-package-wrap" v-if="isGoodsGroup==1 || (isGoodsStatus == 'true' && isGoodsGroup ==0 && goodsType!=1)">
        <div class="c-package-title">优惠介绍</div>
        <div class="c-package-list">
          <div
            class="c-card"
            v-for="(item,index) in goodsPackageList"
            :class="packIndex == index ? 'active' : ''"
            :key="item.id"
            @click="selectPackage(index)"
          >
            
            <div class="f28 fb mb5 mt15">单价:¥{{item.newPrice}}</div>
            <div class="f22 fb">购买{{item.minNum}}~{{item.maxNum}}份</div>
          </div>
        </div>
      </div>
    </div>
    <!--  优惠劵-->
    <select-coupon
      :item="curCoupon"
      :discounted="discounted"
      :usageCouponInfo="usageCouponInfo"
      @select="confirmSelectCoupon"
    ></select-coupon>
    <div class="user-info" v-if="goodsType == constants.goodsType.offlineClass">
      <div>
        <div class="title">购票联系人</div>
        <div class="form-box">
          <span>
            姓名
            <i>*</i>
          </span>
          <input type="text" placeholder="请输入姓名" v-model="form.userName" />
        </div>
        <div class="form-box">
          <span>
            手机号
            <i>*</i>
          </span>
          <input maxlength="11" type="text" placeholder="请输入手机号" v-model="form.mobile" />
        </div>
      </div>
    </div>
    <!-- 选择支付方式 训练营和线下课可以对公支付-->
    <select-pay-way
      v-if="goodsType != constants.goodsType.course && goodsType != constants.goodsType.column"
      @select="confirmSelectPayWay"
      class="mt20 ml30"
    ></select-pay-way>
    <div class="pt40 f26 color-A fb">您购买的商品为虚拟内容服务，不支持退款，请您谅解。</div>
    <div class="footer">
      <div class="box">
        <div>
          <div class="tl">
            <span class="f30 color-333 fb">应付：</span>
            <span class="t color-f5 f40 fb">
              <span class="f30 fb">¥</span>
              {{priceTotal}}
            </span>
            <!-- 个人金额 -->
          </div>
          <div
            class="color-A f22 tl"
            v-if="discounted >0"
          >{{discountTitle}}：¥{{(Number(discounted)).toFixed(2)}}</div>
        </div>
        <gxxt-button class="fb w260" type="primary" @click="jumpToPay()">立即支付</gxxt-button>
      </div>
    </div>
  </div>
  <registration-info
    :showPhone="dataInfo.type != constants.goodsType.offlineClass"
    class="fixed-top"
    v-else
    @confirm="confirmUserInfo"
  ></registration-info>
</template>
<script>
import { wxShare } from '@/utils/wx-config'
import RegistrationInfo from '../registration/registration-info.vue'
import { GxxtButton } from '@/components'
import selectPayWay from './components/select-pay-way.vue'
import selectCoupon from './components/select-coupon.vue'
import mixins from './components/mixins'
export default {
  mixins: [mixins],
  components: {
    RegistrationInfo,
    GxxtButton,
    selectPayWay,
    selectCoupon,
  },
  data() {
    return {
      packIndex:0,
      id: null,
      goodsType: '',
      adminId: null,
      memberVip: false, //是否会员
      showInfo: false, //显示信息收集页
      dataInfo: {},
      isGoodsGroup: 0,
      buyNum: 1,
      goodsPackageList: [],
      payWays: 0,
      disabled: true,
      //购票联系人
      form: {
        userName: '',
        mobile: '',
      },
      packId: 0,
      curPackage: {},
      curCoupon: {},
      usageCouponInfo: {
        couponList: [],
      },
      priceTotal: 0,
      loading: false,
      discountTitle: '',
      discounted: 0,
      studyQuery: '',
      isGoodsStatus: false // false 不可团购
    }
  },
  created() {
    this.isGoodsGroup = this.$route.query.isGoodsGroup;
    this.isGoodsStatus = this.$route.query.isGoodsStatus;
    this.id = this.$route.query.id
    this.adminId = this.$route.query.adminId
    this.goodsType = this.$route.query.goodsType
    this.form.mobile = this.$route.query.mobile ? this.$route.query.mobile : ''
    this.studyQuery = this.$route.query.studyQuery
    this.init()
  },
  watch: {
    goodsType: {
      handler(v) {
        if (v == this.constants.goodsType.offlineClass) {
          this.disabled = false
        } else {
          if (this.isGoodsGroup == 0) {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    async init() {
      this.loading = true
      await this.getCourseInfo()
      this.isGoodsGroup == 1 || (this.isGoodsStatus == 'true' && this.isGoodsGroup ==0 && this.goodsType!=1) ? await this.getGoodsPackageList() : ''
      await this.isMemberVip()
      await this.getUsageCouponInfo()
      this.loading = false
    },
    //获取课程信息
    async getCourseInfo() {
      let res = await this.api.groupBuying.getCourseInfo(this.id, '')
      if (res && res.code == 200) {
        this.dataInfo = res.data
        this.openShare()
      }
    },
    // 团购
    async getGoodsPackageList() {
      let res = await this.api.groupBuying.getGoodsPackageList(this.id)
      if (res && res.code == 200) {
        this.goodsPackageList = res.data
        this.getCurPackage()
      }
    },
    async isMemberVip() {
      let res = await this.api.vip.isMemberVip()
      if (res && res.code == 200) {
        this.memberVip = res.data.memberVip == 0 ? false : true
      }
    },
    async getUsageCouponInfo() {
      let res = await this.api.vip.usageCouponList({
        goodsId: this.id,
        goodsNum: this.buyNum,
        courseType: this.goodsType,
      })
      this.usageCouponInfo = {
        couponList: [],
      }
      this.curCoupon = {}
      if (res && res.code == 200) {
        this.usageCouponInfo = res.data
        if (
          Object.prototype.toString.apply(res.data.couponList) !=
          '[object Array]'
        ) {
          res.data.couponList = []
        }
        this.usageCouponInfo.couponList.forEach((item) => {
          if (item.id == this.usageCouponInfo.id) {
            this.curCoupon = item
          }
        })
      } else {
        this.$toaster({
          message: '获取优惠信息失败',
        })
      }
      this.calculatePrice()
    },
    openShare() {
      let shareInfo = {
        title: this.dataInfo.shareName,
        desc: this.dataInfo.shareDescription,
        link: this.dataInfo.shareLink,
        imgUrl: this.dataInfo.shareImage,
      }
      wxShare({
        shareInfo,
      })
    },
    selectPackage(index) {
      this.packIndex = index;
      this.packId = this.goodsPackageList[index].id
      this.buyNum = this.goodsPackageList[index].minNum
      this.changeBuyNum(); // 选择完计算价格
    },
    confirmSelectPayWay(v) {
      this.payWays = v
    },
    //设置购买个数
    async changeBuyNum() {
      if (this.isGoodsGroup == 1 || (this.isGoodsStatus == 'true' && this.isGoodsGroup ==0 && this.goodsType!=1)) {
        this.getCurPackage()
      }
      this.loading = true
      await this.getUsageCouponInfo()
      this.loading = false
    },
    calculatePrice() {
      this.discountTitle = ''
      this.discounted = 0
      this.payWays2 = this.payWays
      let price = this.dataInfo.newPrice
        ? this.dataInfo.newPrice
        : this.dataInfo.price
      let originPriceTotal = price * this.buyNum
      originPriceTotal = originPriceTotal.toFixed(2) * 1
      if (this.curCoupon.id) {
        let couponType = this.curCoupon.couponType
        let discountMoney = this.curCoupon.discountMoney
        switch (couponType) {
          case 0: {
            this.priceTotal = originPriceTotal - price
            this.discountTitle = '训练营抵扣'
            this.discounted = price
            this.payWays2 = 6
            break
          }
          case 1: {
            this.priceTotal = originPriceTotal - price
            this.discountTitle = '私教坊抵扣'
            this.discounted = price
            this.payWays2 = 6
            break
          }
          case 2: {
            if (originPriceTotal >= this.curCoupon.fullMoney) {
              this.priceTotal = originPriceTotal - discountMoney
              this.discountTitle = '满减优惠'
              this.discounted = discountMoney
            } else {
              this.priceTotal = originPriceTotal
            }
            break
          }
        }
      } else {
        //活动类型:(0：不参与活动 1：训练营抵扣券 2：私教坊抵扣券 3：8折购课 4：满减券 5:团购)
        // 不使用优惠券
        // 团购和会员
        let vipPrice = Infinity,
          groupPrice = Infinity,
          discountTitles = {}
        discountTitles[originPriceTotal] = ''
        if (this.memberVip) {
          vipPrice = originPriceTotal * 0.8
          vipPrice = vipPrice.toFixed(2) * 1
          discountTitles[vipPrice] = '享8折优惠'
          this.discounted = originPriceTotal - vipPrice
        }
        if (this.isGoodsGroup == 1 || (this.isGoodsStatus == 'true' && this.isGoodsGroup ==0 && this.goodsType!=1)) {
          let price = this.curPackage.newPrice
            ? this.curPackage.newPrice
            : this.curPackage.price
          groupPrice = price * this.buyNum
          groupPrice = groupPrice.toFixed(2) * 1
          discountTitles[groupPrice] = '团购优惠'
          this.discounted = originPriceTotal - groupPrice
          this.usageCouponInfo.usageType = 5;
        }
        this.priceTotal = Math.min(
          vipPrice * 1,
          groupPrice * 1,
          originPriceTotal * 1
        )
        this.discountTitle = discountTitles[this.priceTotal]
      }
      if (this.priceTotal == 0) {
        this.payWays2 = 5
      }
    },
    getCurPackage() {
      // curPackage
      this.goodsPackageList.forEach((item) => {
        if (this.buyNum <= item.maxNum && this.buyNum >= item.minNum) {
          this.curPackage = item
        }
      })
    },
    confirmSelectCoupon(item) {
      this.curCoupon = item
      this.calculatePrice()
    },
    jumpToPay() {
      if (this.goodsType == this.constants.goodsType.offlineClass) {
        let res = this.checkForm()
        if (!res) return
      }
      if (this.payWays == 4) {
        this.corporatePay()
      } else {
        this.weChatPay()
      }
    },
    checkForm() {
      if (!this.form.userName) {
        this.$toaster({
          message: '用户姓名不能为空',
          duration: 3000,
          show: true,
        })
        return false
      }
      let mobileReg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.form.mobile === '') {
        this.$toaster({
          message: '手机号不能为空',
          duration: 3000,
          show: true,
        })
        return false
      } else if (!mobileReg.test(this.form.mobile)) {
        this.$toaster({
          message: '请正确填写您的手机号码！',
          duration: 3000,
          show: true,
        })
        return false
      }
      return true
    },
  },
}
</script>

<style lang="less" scoped>
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #aaaaaa;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #aaaaaa;
}

input:-ms-input-placeholder {
  color: #aaaaaa;
}

input::-webkit-input-placeholder {
  color: #aaaaaa;
}

.order-info {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  padding: 10px 0 300px 0;
  overflow-y: scroll;

  .personal {
    height: 256px !important;
  }

  .order-list {
    padding: 32px 32px 40px 32px;
    width: 686px;
    // height: 482px;
    background: #ffffff;
    margin: 32px 32px 20px 32px;

    .order-box {
      // width: 686px;
      height: 200px;
      border-radius: 10px;
      // padding: 36px 0 40px 28px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;

      .c-thumb {
        flex: 150px 0 0;
        height: 200px;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .o-content {
        width: 508px;
        padding: 0 0 0 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .c-title {
          width: 446px;
          font-size: 30px;
          font-weight: 500;
          color: #222222;
          line-height: 1;
          overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          text-align: left;
        }
        .c-price {
          line-height: 1;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 30px 0 0 0;
          .c-x-1 {
            font-size: 26px;
            font-weight: 500;
            color: #c0c1c3;
            letter-spacing: 2px;
            padding-left: 30px;
          }
        }
      }
      .text {
        text-align: left;
        padding-top: 58px;
        span:nth-child(1) {
          padding: 0 10px;
          line-height: 32px;
          background: #fff3ed;
          border-radius: 4px;
          margin-right: 20px;
        }
        span {
          font-size: 20px;
          color: #ff5500;
        }
      }
    }
  }

  .footer {
    width: 750px;
    padding: 32px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    background: #ffffff;

    .box {
      height: 110px;
      box-shadow: 0px 0px 0px 0px rgba(212, 212, 212, 0.5);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .user-info {
    padding: 30px;
    width: 686px;
    background-color: #fff;
    margin: 0 auto;

    .title {
      color: #333;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: left;
    }

    .form-box {
      width: 630px;
      text-align: left;
      border-bottom: 1px solid #e9e9e9;
      display: flex;
      line-height: 70px;

      span {
        width: 120px;
        font-size: 30px;
        color: #333;
        font-weight: 500;
        i {
          color: #f60e0e;
          font-size: 28px;
          font-style: normal;
        }
      }

      input {
        flex: 1;
        font-size: 30px;
        color: #333;
        font-weight: 500;
        height: 70px;
        padding-left: 20px;
        text-align: right;
      }
    }
  }
}
.c-package-wrap {
  .c-package-title {
    line-height: 1;
    font-size: 30px;
    color: #333333;
    text-align: left;
    font-weight: bold;
    margin: 40px 0 20px 0;
  }

  .c-package-list {
    display: flex;
    overflow: auto;

    .c-card {
      flex: 220px 0 0;
      height: 120px;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 20px;
      color: #b87741;
      background: url(../../assets/images/coupon.png) 0 0 no-repeat;
      box-shadow: 0px 4px 6px 0px rgba(105, 75, 39, 0.1);
      background-size: 100% 100%;
      &.active {
        color: #fff;
        background-image: url(../../assets/images/coupon-bg.png);
      }
    }
  }
}
.fixed-top {
  top: 0;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 99;
  width: 750px;
}
</style>
